<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="dedicationPage">
<p class="paraCenter">For Therese, my love;</p>
<p class="paraCenter">Jennifer, our angel;</p>
<p class="paraCenter">Bert, our pride; and Evan, our joy.</p>
<p class="paraCenter">God has blessed me through you.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TriumphandDefeat_dedicationPage.vue?5aa280fc